/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    export class CampaignSinonimDialog extends NoboxEntityDialog<SinonimForm, any> {
        protected getFormKey() { return SinonimForm.formKey; }

        protected form = new SinonimForm(this.idPrefix);
        public textareaEl: JQuery; 
        constructor(container?: JQuery) {
            super(container);

            if ($.cookie("LanguagePreference")) {
                this.form.Language.set_value($.cookie("LanguagePreference"));
            } else {
                this.form.Language.set_value("en");
            }
            
            this.form.Key.change(() => {
                var value = this.form.Key.value as any;
                var valueText = this.form.Key.text;
                var textarea = this.textareaEl;
                if (!Q.isEmptyOrNull(value)) {
                    if (isNaN(value)) {
                        var result = `[${valueText}]`;
                        this.form.Result.value = result;
                    } else {
                        Q.serviceCall({
                            url: "/Services/Master/Sinonim/Retrieve",
                            blockUI: false,
                            request: {
                                EntityId: value
                            },
                            onSuccess: (res: Serenity.RetrieveResponse<Master.SinonimRow>) => {
                                var item = res.Entity;
                                var replaceComa = Q.replaceAll(res.Entity.Hsl, ", ", "|");
                                var replaceSymbol = Q.replaceAll(replaceComa, ") ", "");
                                var replaceSymbol1 = Q.replaceAll(replaceSymbol, " (", "");
                                var replaceSymbol2 = Q.replaceAll(replaceSymbol1, ")", "");
                                var replaceSymbol3 = Q.replaceAll(replaceSymbol2, "(", "");
                                var replaceSymbol4 = replaceSymbol3.replace(/(?<=\[)(.*?)(?=\])/g, "");
                                var replaceSymbol5 = Q.replaceAll(replaceSymbol4, "[ ", "");
                                var replaceSymbol6 = Q.replaceAll(replaceSymbol5, " ]", "");
                                var replaceSymbol7 = Q.replaceAll(replaceSymbol6, "]", "");
                                var replaceSymbol8 = Q.replaceAll(replaceSymbol7, "[", "");
                                var replaceSymbol9 = replaceSymbol8.replace(/[0-9]/g, "");
                                var replaceSymbol10 = Q.replaceAll(replaceSymbol9, ";", "|");
                                var replaceSymbol11 = replaceSymbol10.replace(/(?<=\|)\s+|\s+(?=\|)/g, '');
                                if (replaceSymbol11.substring(replaceSymbol11.length - 1) == "|") {
                                    replaceSymbol11 = replaceSymbol11.substring(0, replaceSymbol11.length - 1)
                                }
                                var result = `[${valueText}|${Q.trim(replaceSymbol11)}]`;
                                this.form.Result.value = result;
                            },
                            onError: error => {
                                var result = `[${valueText}]`;
                                this.form.Result.value = result;
                            }
                        });
                    }
                }
            });
        }

        protected updateTitle() {
            if (this.isEditMode()) {
                this.dialogTitle = "Synonym";
            } else {
                this.dialogTitle = "Synonym";
            }
        }

        protected getToolbarButtons() {
            return [];
        }

        protected getDialogButtons() {
            var buttons = [] as Serenity.DialogButton[];
            buttons.push({
                text: "Add",
                cssClass: "bg-primary",
                click: () => {
                    if (this.validateForm()) {
                        this.setCharSelected(this.textareaEl, this.form.Result.value);
                        this.dialogClose();
                    }
                }
            });
            return buttons;
        }

        getSelected(textArea) {
            var text = textArea.value;
            var indexStart = textArea.selectionStart;
            var indexEnd = textArea.selectionEnd;
            return text.substring(indexStart, indexEnd);
        }

        setCharSelected(textArea, char) {
            var text = textArea.value;
            var indexStart = textArea.selectionStart;
            var indexEnd = textArea.selectionEnd;
            if (indexStart == indexEnd) {
                var text2 = this.addStr(text, indexEnd, char);
                textArea.value = text2;
            } else {
                $(textArea).replaceSelectedText(char);
            }
        }

        addStr(str, index, stringToAdd) {
            return str.substring(0, index) + stringToAdd + str.substring(index, str.length);
        }

        //protected updateInterface() {
        //    super.updateInterface();
        //    if (this.isNew()) {
        //        var chId = this.getCookie("Channel");
        //        Serenity.EditorUtils.setValue(this.form.ChannelId, chId);
        //        Serenity.EditorUtils.setValue(this.form.ProcessBy, this.getCookie("Accounts"));
        //    }
        //    var item = this.get_entity();
        //    if (this.isEditMode()) {
        //        if (item.CampaignId!=null) {
        //            this.form.ChannelId.set_value(item.CampaignId.toString());
        //        }
        //        if (item.BodyType == 0) {
        //            this.form.BodyHtml.getGridField().toggle(false);
        //            this.form.BodyText.getGridField().toggle(true);
        //            this.form.BodyText.value = item.Body;
        //            Serenity.EditorUtils.setRequired(this.form.BodyText, true);
        //        } else if (item.BodyType == 1) {
        //            this.form.BodyHtml.getGridField().toggle(true);
        //            this.form.BodyText.getGridField().toggle(false);
        //            this.form.BodyHtml.set_value(item.Body);
        //            Serenity.EditorUtils.setRequired(this.form.BodyHtml, true);
        //            Serenity.EditorUtils.setRequired(this.form.BodyText, false);
        //        }
        //    }
        //}
    }
}